import { Button, Col, Row } from 'react-bootstrap'
import { ArrowUturnLeftIcon, FunnelIcon } from '@heroicons/react/24/outline'

import { alertService } from '../../../../../../_services/alert.service'
import { formatDate } from '../../../../../../utils/date'

const Footer = ({
    adavnceFilterFormVal,
    callBackfunc,
    checkBoxSelectOptions,
    depId,
    dir,
    fieldCount,
    simulationObj,
    isTable,
    t,
    submitFunc,
    setFilterState,
    clusterId,
    fieldArrayId,
    editionId,
}) => {
    const advanceFilterSubmit = () => {
        let isFilleterByDate = false
        let isFilleterByFieldWidth = false
        let isContainsArchivedProducts = false
        let isContainsBlockedSalesProducts = false
        let planogramVersion = []
        let planogramEditions = []

        // Date validation
        if (
            adavnceFilterFormVal.actvationDate.from ||
            adavnceFilterFormVal.actvationDate.to
        ) {
            const fromDate = new Date(adavnceFilterFormVal.actvationDate.from)
            const toDate = new Date(adavnceFilterFormVal.actvationDate.to)
            if (!adavnceFilterFormVal.actvationDate.from)
                return alertService.error(t('PLEASE_SET_A_FROM_DATE'))
            if (!adavnceFilterFormVal.actvationDate.to)
                return alertService.error(t('PLEASE_SET_TO_DATE'))
            if (fromDate > toDate) {
                return alertService.error(t('PLEASE_SET_VALID_DATE_RANGE'))
            }
            isFilleterByDate = true
        }

        // Fields Width validation
        if (
            adavnceFilterFormVal.fieldsWidth.from ||
            adavnceFilterFormVal.fieldsWidth.to ||
            adavnceFilterFormVal.fieldsWidth.from === 0 ||
            adavnceFilterFormVal.fieldsWidth.to === 0
        ) {
            if (
                adavnceFilterFormVal.fieldsWidth.to == null ||
                adavnceFilterFormVal.fieldsWidth.to === ''
            )
                return alertService.error(t('SET_FIELDS_WIDTH_TO'))
            if (
                adavnceFilterFormVal.fieldsWidth.from == null ||
                adavnceFilterFormVal.fieldsWidth.from === ''
            )
                return alertService.error(t('SET_FIELDS_WIDTH_FROM'))
            if (
                adavnceFilterFormVal.fieldsWidth.from >
                adavnceFilterFormVal.fieldsWidth.to
            )
                return alertService.error(t('ERROR_FIELD_WIDTH'), 5000)
            isFilleterByFieldWidth = true
        }

        // Radio button value set
        if (checkBoxSelectOptions === 'archivedProduct')
            isContainsArchivedProducts = true
        if (checkBoxSelectOptions === 'blockedProduct')
            isContainsBlockedSalesProducts = true

        if (adavnceFilterFormVal.version)
            adavnceFilterFormVal.version?.map((item) =>
                planogramVersion.push(item.value)
            )

        if (adavnceFilterFormVal.edition)
            adavnceFilterFormVal.edition?.map((item) =>
                planogramEditions.push(item.value)
            )

        const simulationFilterPayload = {
            maxResult: 7,
            startIndex: 0,
            isReqCount: true,
            planogramName: '',

            productOrBarcode: adavnceFilterFormVal?.productOrBarcode,
            isFilleterByLastModifiedDate: isFilleterByDate,
            planogramLastModifiedFromDate: adavnceFilterFormVal.actvationDate
                ?.from
                ? `${formatDate(
                      adavnceFilterFormVal.actvationDate?.from
                  )} 0:00:00`
                : '',
            planogramLastModifiedToDate: adavnceFilterFormVal.actvationDate?.to
                ? `${formatDate(
                      adavnceFilterFormVal.actvationDate?.to
                  )} 23:59:59`
                : '',
            departmentIds: [depId],
            planogramVersion: planogramVersion,
            editionIds: planogramEditions,
            clusterId: clusterId || -1,
            fieldArrayId: fieldArrayId || -1,
            isFilleterByFieldCount: true,
            fieldCountFrom: simulationObj.fieldList.length,
            fieldCountTo: simulationObj.fieldList.length,
            isFilleterByFieldWidth: isFilleterByFieldWidth,
            fieldsWidthFrom: adavnceFilterFormVal.fieldsWidth?.from
                ? adavnceFilterFormVal.fieldsWidth?.from
                : '',
            fieldsWidthTo: adavnceFilterFormVal.fieldsWidth?.to
                ? adavnceFilterFormVal.fieldsWidth?.to
                : '',
            isReqPagination: true,
            sortBy: '',
            sortOrder: '',
            isContainsArchivedProducts: isContainsArchivedProducts,
            isContainsBlockedSalesProducts: isContainsBlockedSalesProducts,
            isContainsBlockedOrderProducts: false,
        }

        setFilterState(simulationFilterPayload)
        submitFunc(simulationFilterPayload)
    }
    return (
        <div>
            <Row className={'mt-5 mb-4'}>
                <div
                    style={{
                        paddingLeft: 10,
                        paddingRight: 10,
                        width: '100%',
                        height: 1,
                        backgroundColor: '#BDBDBD',
                    }}
                ></div>
            </Row>
            {/* Footer section */}
            <Row dir={dir} className="justify-content-end mt-2">
                <Col xs="auto">
                    <Button
                        dir={dir}
                        variant="outline-secondary"
                        className="me-2 btn-custom-clear"
                        onClick={() => callBackfunc()}
                    >
                        <span className="btn-name">{ isTable ? t('btnnames.back') : t('CLEAR')}</span>
                        <ArrowUturnLeftIcon
                            style={{
                                width: 19,
                                height: 19,
                                marginLeft: 5,
                                marginRight: 5,
                            }}
                        />
                    </Button>
                </Col>
                {!isTable && (
                    <Col xs="auto">
                        <Button
                            dir={dir}
                            className="apply-button btn-custom-apply"
                            onClick={() => advanceFilterSubmit()}
                        >
                            <span className="btn-name">
                                {t('APPLY_FILTERS')}
                            </span>
                            <FunnelIcon
                                style={{
                                    width: 19,
                                    height: 19,
                                    marginLeft: 5,
                                    marginRight: 5,
                                }}
                            />
                        </Button>
                    </Col>
                )}
            </Row>
        </div>
    )
}

export default Footer
